<template>
	<v-img
		:src="
			require(`@/assets/images/now-be-success-background-${userDevice}.png`)
		"
		height="360"
		class="pt-12 pb-12"
	>
		<h2 class="font-weight-bold sub--title mt-4 mt-sm-9 mb-3">
			{{ $t('now-be-success.sub-title') }}
		</h2>
		<h1 class="text-center main-title mb-7 mb-sm-12 white-space-pre">
			{{ $t('now-be-success.title') }}
		</h1>
	</v-img>
</template>

<script>
export default {
	computed: {
		userDevice() {
			return this.$store.getters['userDevice']
		},
	},
}
</script>

<style lang="scss" scoped>
.wrap {
	background-image: linear-gradient(120deg, #6aaeff 0%, #6b72fa 78%);
}

.sub--title {
	font-size: 18px;
	letter-spacing: -0.9px;
	text-align: center;
	color: #fff;
}
.main-title {
	font-size: 30px;
	font-weight: bold;
	letter-spacing: -1.5px;
	color: #fff;
}
@media screen and (max-width: 600px) {
	.main-title {
		font-size: 28px;
		font-weight: bold;
		letter-spacing: -1.4px;
	}
}
</style>
